import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/Rx";
import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
import { removeNullishFieldsParams } from "../../shared/object_helpers";
import { environment } from "./../../../environments/environment";

@Injectable()
export class ReservationService {
  baseUrl: string = environment.api_base_url;
  // baseUrl: string = 'http://192.168.8.100:8000/api/';

  constructor(private http: HttpClient) {}

  getReservations(): any {
    return this.http.get(`${this.baseUrl}reservations`);
  }

  getReservationActivityLogs(id): any {
    return this.http.get(`${this.baseUrl}reservations/${id}/get-logs`);
  }

  sendReservationToERP(id) {
    return this.http.post(`${this.baseUrl}reservations/${id}/send_to_erp`, {});
  }

  postReservation(data) {
    return this.http.post(`${this.baseUrl}reservations`, JSON.stringify(data));
  }

  printPartnerCheque(reservation_id: number) {
    return this.http.get(
      `${this.baseUrl}reservations/reservation_partner_cheque/${reservation_id}`
    );
  }

  filterLeadByName(name, token) {
    let data = {
      keyword: name,
    };
    console.log(data);
    return this.http.post(
      `${this.baseUrl}reservations/search`,
      JSON.stringify(data)
    );
  }

  blockUnitAtReservation(id) {
    return this.http.put(`${this.baseUrl}blocks/${id}/temp_block`, {});
  }

  // accountantAcceptReservation(id){
  //   return this.http.put(`${this.baseUrl}reservations/request/${id}/accept`, {});
  // }

  accountDeclineReservation(id) {
    return this.http.put(
      `${this.baseUrl}reservations/request/accountant/${id}/decline`,
      {}
    );
  }

  adminDeclineReservations(id) {
    return this.http.put(
      `${this.baseUrl}reservations/request/${id}/decline`,
      {}
    );
  }

  getAllContractsTempaltes() {
    return this.http.get(`${this.baseUrl}contracts_templates`);
  }

  getParentTemplates(project_id?) {
    if (project_id) {
      return this.http.get(
        `${this.baseUrl}contracts_templates?parentsOnly=true&project_id=${project_id}`
      );
    } else {
      return this.http.get(
        `${this.baseUrl}contracts_templates?parentsOnly=true`
      );
    }
  }

  getContractsTemplates(unit_id) {
    return this.http.get(
      `${this.baseUrl}contracts/get-contracts-by-locations/${unit_id}`
    );
  }

  addContractTemplate(payload) {
    return this.http.post(`${this.baseUrl}contracts_templates`, payload);
  }

  getContractData(id) {
    return this.http.get(`${this.baseUrl}contracts_templates/${id}`);
  }

  updateContractdata(id, payload) {
    return this.http.put(`${this.baseUrl}contracts_templates/${id}`, payload);
  }

  deleteContract(id) {
    return this.http.delete(`${this.baseUrl}contracts_templates/${id}`);
  }

  contractorApproved(data) {
    return this.http.post(
      `${this.baseUrl}reservations/request/contractor/accept`,
      JSON.stringify(data)
    );
  }

  unblock(unit_id) {
    return this.http.get(`${this.baseUrl}unblock/unit/${unit_id}`);
  }
  
  collectFromCDB(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${reservation_id}/collect_from_cdb`,
      payload
    );
  }

  collectFineFromCDB(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}fines/${reservation_id}/collect_from_cdb`,
      payload
    );
  }

  adminDecline(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/request/${reservation_id}/decline`,
      payload
    );
  }

  filterReservations(data) {
    const params = new HttpParams()
      .set("agents", data.agents.join())
      .set("serial", data.serial)
      .set("rf_serial", data.rf_serial)
      .set("contract_status", data.contractStatus)
      .set("grant_commission", data.grant_commission.join())
      .set("statuses", data.statuses.join())
      .set("overseas", data.overseas.join())
      .set("event_ids", data.event_ids.join())
      .set("cheques", data.cheques.join())
      .set("broker_id", data.broker_id.join())
      .set("lead_name", data.lead_name)
      .set("location", data.location)
      .set("project_id", data.project_id)
      .set("date_from", data.date_from)
      .set("date_to", data.date_to)
      .set("approve_refund_request_date_from", data.approve_refund_request_date_from)
      .set("approve_refund_request_date_to", data.approve_refund_request_date_to)
      .set("is_deposit", data.is_deposit)
      .set("is_commissioned", data.is_commissioned)
      .set("reservation_form_signed", data.reservation_form_signed)
      .set("is_collect_down_payment", data.is_collect_down_payment)
      .set("is_bank_transfer", data.is_bank_transfer);
    return this.http.get(`${this.baseUrl}reservations/filter/unit`, { params });
  }

  filterReservationsByLeadId(lead_id) {
    return this.http.get(
      `${this.baseUrl}reservations/lead_reservaions/${lead_id}`
    );
  }

  exportTable(data?) {
    if (data) {
      let params = new HttpParams()
        .set("agents", data.agents.join())
        .set("serial", data.serial)
        .set("rf_serial", data.rf_serial)
        .set("contract_status", data.contractStatus)
        .set("grant_commission", data.grant_commission.join())
        .set("statuses", data.statuses.join())
        .set("overseas", data.overseas.join())
        .set("event_ids", data.event_ids.join())
        .set("cheques", data.cheques.join())
        .set("lead_name", data.lead_name)
        .set("project_id", data.project_id)
        .set("broker_id", data.broker_id.join())
        .set("date_from", data.date_from)
        .set("date_to", data.date_to)
        .set("is_deposit", data.is_deposit)
        .set("is_commissioned", data.is_commissioned)
        .set("reservation_form_signed", data.reservation_form_signed)
        .set("is_collect_down_payment", data.is_collect_down_payment)
        .set("is_bank_transfer", data.is_bank_transfer)
        .set("is_export", "1");
      return this.http.get(`${this.baseUrl}reservations/filter/unit`, {
        params,
      });
    }
    return this.http.get(`${this.baseUrl}reservations/filter/unit`);
  }

  exportPaymentCollectionsTable(params = {}) {
    return this.http.get(`${this.baseUrl}paymentCollections`, {
      params: removeNullishFieldsParams(params),
    });
  }
  exportAllPaymentCollectionsTable() {
    return this.http.get(`${this.baseUrl}paymentCollections/export/all`);
  }

  infinitWithPagination(url, data) {
    let params = new HttpParams()
      .set("agents", data.agents.join())
      .set("serial", data.serial)
      .set("rf_serial", data.rf_serial)
      .set("contract_status", data.contractStatus)
      .set("statuses", data.statuses.join())
      .set("lead_name", data.lead_name)
      .set("project_id", data.project_id)
      .set("broker_id", data.broker_id.join())
      .set("date_from", data.date_from)
      .set("date_to", data.date_to)
      .set("is_deposit", data.is_deposit)
      .set("is_commissioned", data.is_commissioned)
      .set("grant_commission", data.grant_commission)
      .set("reservation_form_signed", data.reservation_form_signed);
    return this.http.get(`${url}`, { params });
  }

  assignToLead(res_id, assign_user) {
    return this.http.get(
      `${this.baseUrl}assign/reservation/${res_id}/to/${assign_user}`
    );
  }

  deleteReservation(res_id) {
    return this.http.get(`${this.baseUrl}reservations/delete/${res_id}`);
  }

  installmentPdf(data) {
    return this.http.post(
      `${this.baseUrl}generate/reservation/installments/pdf`,
      JSON.stringify(data)
    );
  }

  generateContract(data) {
    data = removeNullishFieldsParams(data);
    return this.http.post(
      `${this.baseUrl}contracts/generate_contract`,
      JSON.stringify(data)
    );
  }

  contract_sign_by_client(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/request/contract/${reservation_id}`,
      JSON.stringify(payload)
    );
  }

  reservation_form_signed(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/request/reservation_form_signed/${reservation_id}`,
      JSON.stringify(payload)
    );
  }

  contract_approve(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/request/contract/${reservation_id}/approve`,
      JSON.stringify(payload)
    );
  }

  contract_delivered(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/request/contract/${reservation_id}/delivered`,
      JSON.stringify(payload)
    );
  }

  cheque_recieved(reservation_id, data) {
    return this.http.put(
      `${this.baseUrl}reservations/request/contract/${reservation_id}/chequeRecieved`,
      data
    );
  }

  cancel_cheque_recieved(reservation_id) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/cancel_cheque_recieved`,
      {}
    );
  }

  addReservationComment(reservation_id, comment) {
    return this.http.post(
      `${this.baseUrl}reservations/${reservation_id}/comment`,
      JSON.stringify({ comment: comment })
    );
  }

  changeSignatureDate(id, date) {
    return this.http.post(
      `${this.baseUrl}reservations/request/contract/${id}/change`,
      JSON.stringify(date)
    );
  }

  editSellingPrice(id, data) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/change_selling_price`,
      JSON.stringify(data)
    );
  }

  changeSellingDate(id, data) {
    return this.http.post(
      `${this.baseUrl}reservations/request/contract/${id}/change_selling_date`,
      JSON.stringify(data)
    );
  }

  changeConfirmationDate(id, data) {
    return this.http.post(
      `${this.baseUrl}reservations/${id}/update_confirmation_date`,
      JSON.stringify(data)
    );
  }

  accountantApprove(id, data) {
    return this.http.put(
      `${this.baseUrl}reservations/request/${id}/accept`,
      JSON.stringify(data)
    );
  }

  // bank transfer
  getBankTransfer(id) {
    return this.http.get(
      `${this.baseUrl}reservations/${id}/get_bank_transfers`
    );
  }

  addBankTransfer(id, data) {
    return this.http.post(
      `${this.baseUrl}reservations/${id}/add_bank_transfer`,
      data
    );
  }

  importReservation(data) {
    return this.http.post(
      `${this.baseUrl}reservation/import`,
      JSON.stringify(data)
    );
  }

  reAssignToLead(data) {
    return this.http.post(
      `${this.baseUrl}assign/lead/reservation`,
      JSON.stringify(data)
    );
  }

  getSingleReservation(id) {
    return this.http.get(`${this.baseUrl}reservations/${id}`);
  }

  changeDealType(data) {
    return this.http.post(
      `${this.baseUrl}reservations/change_division`,
      JSON.stringify(data)
    );
  }

  changeEvent(id, data) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/change_event`,
      data
    );
  }

  makeCommission(id, date) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/commission`,
      JSON.stringify(date)
    );
  }

  makeClaim(id, payload) {
    return this.http.put(`${this.baseUrl}reservations/${id}/claim`, payload);
  }

  getProjects(params: any = {}) {
    return this.http.get(`${this.baseUrl}list_projects`, { params });
  }

  assign_payment_term(data): any {
    return this.http.put(
      `${this.baseUrl}projects/assign_payment_term`,
      JSON.stringify(data)
    );
  }

  changeGarageSlots(data) {
    return this.http.post(
      `${this.baseUrl}change_garage/slots`,
      JSON.stringify(data)
    );
  }

  changeGrantCommission(reservation, data) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation}/change_grant_commission`,
      JSON.stringify(data)
    );
  }

  changeSlots(data) {
    return this.http.post(
      `${this.baseUrl}change_service_room/slots`,
      JSON.stringify(data)
    );
  }

  addContractLog(data) {
    return this.http.post(
      `${this.baseUrl}contracts/save_log`,
      JSON.stringify(data)
    );
  }

  changeOverseas(id, data) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/change_overseas`,
      JSON.stringify(data)
    );
  }

  changePaymentType(id, data) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/change_payment_type`,
      JSON.stringify(data)
    );
  }
  changePaymentTerm(id, data) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/change_payment_term`,
      JSON.stringify(data)
    );
  }

  generateReservationForAgent() {
    return this.http.get(`${this.baseUrl}generate/reservations/pdf`);
  }

  getGeneralSettings() {
    return this.http.get(`${this.baseUrl}remote/config/general_settings`);
  }

  updateGeneralSettings(payload) {
    return this.http.put(
      `${this.baseUrl}remote/config/general_settings`,
      JSON.stringify(payload)
    );
  }

  editLeadInReservation(id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/update_lead_info/${id}`,
      JSON.stringify(payload)
    );
  }

  cancelReservationReasonDate(id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/cancel_reason_date/${id}`,
      JSON.stringify(payload)
    );
  }

  reactivateReservation(id) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/reactivate_reservation`,
      {}
    );
  }

  changeContractType(id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/change_contract`,
      payload
    );
  }

  getSharedComissions(id) {
    return this.http.get(`${this.baseUrl}reservations/${id}/sharedCommission`);
  }

  addShareComission(id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/${id}/sharedCommission`,
      payload
    );
  }

  sentOverSeaContract(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/send_contract/${reservation_id}`,
      payload
    );
  }

  changeContractDate(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/change_contract_date`,
      payload
    );
  }

  changeDeliveryDate(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/change_delivery_date`,
      payload
    );
  }

  sendCourierDate(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/send_by_courier`,
      payload
    );
  }

  receviedFromCourier(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/received_from_courier`,
      payload
    );
  }

  getAllPaymentCollections() {
    return this.http.get(`${this.baseUrl}paymentCollections`);
  }

  getSinglePaymentCollection(id) {
    return this.http.get(`${this.baseUrl}paymentCollections/showPayment/${id}`);
  }

  getPaymentCollectionForAReservation(reservation_id) {
    return this.http.get(`${this.baseUrl}paymentCollections/${reservation_id}`);
  }

  getReservationFines(params = {}) {
    return this.http.get(`${this.baseUrl}fines`, {
      params: removeNullishFieldsParams(params),
    });
  }

  getReservationTickets(reservation_id) {
    return this.http.get(
      `${this.baseUrl}reservations/tickets/${reservation_id}`
    );
  }

  updatePaymentCollectionStatus(collection_id, status) {
    return this.http.put(
      `${this.baseUrl}paymentCollections/${collection_id}`,
      status
    );
  }

  completeDownPayment(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/complete_down_payment`,
      payload
    );
  }

  addDocument(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/${reservation_id}/document`,
      payload
    );
  }

  getReservationDocuments(reservation_id) {
    return this.http.get(
      `${this.baseUrl}reservations/${reservation_id}/document`
    );
  }

  deleteReservationDocument(reservation_id, id) {
    return this.http.delete(
      `${this.baseUrl}reservations/${reservation_id}/document/${id}`
    );
  }

  cancelSendOverseasContract(reservation_id) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/cancel_send_overseas_contract`,
      {}
    );
  }

  cancelContractReview(reservation_id) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/cancel_contract_review`,
      {}
    );
  }

  cancelContractSignedByClient(reservation_id) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/cancel_contract_signed_by_client`,
      {}
    );
  }

  cancelContractApprove(reservation_id) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/cancel_contract_approve`,
      {}
    );
  }

  cancelContractDelivered(reservation_id) {
    return this.http.put(
      `${this.baseUrl}reservations/${reservation_id}/cancel_contract_delivered`,
      {}
    );
  }

  downloadReservation(reservation_id) {
    return this.http.post(
      `${this.baseUrl}reservations/${reservation_id}/generate_reservation_file`,
      {}
    );
  }

  exportFinalPaymentPlan(reservation_id) {
    return this.http.get(
      `${this.baseUrl}paymentCollections/${reservation_id}/export`,
      {
        responseType: "text",
      }
    );
  }

  importFinalPaymentPlan(
    reservation_id,
    fileObj: { file_name: string; file: string }
  ) {
    return this.http.put(
      `${this.baseUrl}paymentCollections/${reservation_id}/import`,
      fileObj
    );
  }

  cancelComissions(id) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/cancel_commission`,
      {}
    );
  }

  cancelExtraDiscount(id) {
    return this.http.put(
      `${this.baseUrl}reservations/${id}/cancel_extra_discount`,
      {}
    );
  }

  printFinalPaymentPlan(id) {
    return this.http.get(`${this.baseUrl}paymentCollections/${id}/print_final`);
  }

  variablesContracts() {
    return this.http.get(`${this.baseUrl}contracts_templates/get_variables`);
  }

  deleteFinalPaymentPlanCollection(id) {
    return this.http.delete(`${this.baseUrl}paymentCollections/${id}`);
  }
  addLead(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/${reservation_id}/add_lead`,
      payload
    );
  }
  deleteLead(reservation_id, lead_id) {
    return this.http.delete(
      `${this.baseUrl}reservations/${reservation_id}/delete_lead/${lead_id}`
    );
  }

  // events apis

  getAllActivitesForLeadsFilter() {
    return this.http.get(`${this.baseUrl}leads-activities_for_filter`);
  }

  addEvent(data) {
    return this.http.post(`${this.baseUrl}leads-events`, JSON.stringify(data));
  }

  editEvent(id, payload) {
    return this.http.put(
      `${this.baseUrl}leads-events/${id}`,
      JSON.stringify(payload)
    );
  }

  deleteEvent(id) {
    return this.http.delete(`${this.baseUrl}leads-events/${id}`);
  }
  getAllEventsPaginated(page?) {
    return this.http.get(
      `${this.baseUrl}leads-events?paginate=${true}&page=${page || 1}`
    );
  }
  getAllEvents() {
    return this.http.get(`${this.baseUrl}leads-events`);
  }

  getUnitsByProject(project_id): Observable<any> {
    return this.http.get(
      `${this.baseUrl}units/availableUnitsByProject/${project_id}`
    );
  }

  // cheques book
  printCheques(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/${reservation_id}/print_cheques`,
      payload
    );
  }

  enableOrDisableReminderCheque(id, payload) {
    return this.http.put(
      `${this.baseUrl}paymentCollections/${id}/change_reminder_status`,
      payload
    );
  }

  uploadScannedCheque(id, payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/upload_scanned_cheques`,
      payload
    );
  }

  hideOrShowCheque(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}paymentCollections/${reservation_id}/change_print_status`,
      payload
    );
  }

  deleteCheque(payload) {
    return this.http.post(`${this.baseUrl}paymentCollections/delete`, payload);
  }

  addCheque(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${reservation_id}/add_cheque`,
      payload
    );
  }
  // payment-collections

  getbanks() {
    return this.http.get(`${this.baseUrl}banks`);
  }

  getAllCurrencies() {
    return this.http.get(`${this.baseUrl}paymentCollections/currencies/get`);
  }

  filterPaymentCollections(params = {}) {
    return this.http.get(`${this.baseUrl}paymentCollections`, {
      params: removeNullishFieldsParams(params),
    });
  }

  bouncedCheques(payload) {
    return this.http.post(`${this.baseUrl}paymentCollections/change_status/bounced_cheques`, payload);
  }

  getPaymentCollectionStats(params) {
    return this.http.get(`${this.baseUrl}paymentCollections/cards/get_stats`, {
      params: removeNullishFieldsParams(params),
    });
  }

  getAllRejectReasons() {
    return this.http.get(`${this.baseUrl}settings/paymentRejectReasons`);
  }

  infiniPaymentsWithPagination(url, params = {}) {
    return this.http.get(`${url}`, {
      params: removeNullishFieldsParams(params),
    });
  }

  importPayment(data) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/import/bulk`,
      JSON.stringify(data)
    );
  }

  importFines(data) {
    return this.http.post(
      `${this.baseUrl}fines/import/bulk`,
      JSON.stringify(data)
    );
  }

  collectCheque(id, payload, filter_data = null) {
    payload = removeNullishFieldsParams(payload);
    filter_data = removeNullishFieldsParams(filter_data);
    if (filter_data) {
      return this.http.post(`${this.baseUrl}paymentCollections/${id}/collect`, {
        ...payload,
        ...filter_data,
      });
    } else {
      return this.http.post(
        `${this.baseUrl}paymentCollections/${id}/collect`,
        payload
      );
    }
  }

  changeSettlementStatus(id) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/change_settlement_status`,
      {}
    );
  }

  collectBulkCheques(payload) {
    payload = removeNullishFieldsParams(payload);
    return this.http.post(
      `${this.baseUrl}payment-collections/collect_cheques`,
      payload
    );
  }

  collectChequeFine(id, payload, filter_data = null) {
    if (filter_data) {
      return this.http.post(`${this.baseUrl}fines/${id}/collect`, {
        ...payload,
        ...filter_data,
      });
    } else {
      return this.http.post(`${this.baseUrl}fines/${id}/collect`, payload);
    }
  }

  addCDB(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${reservation_id}/add_cdb_amount`,
      payload
    );
  }

  addDelayFine(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}fines/${reservation_id}/store_delay_fine`,
      payload
    );
  }

  deleteReservationFine(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}fines/${reservation_id}/delete`,
      payload
    );
  }

  uploadScannedFiles(reservation_id, document_id, payload) {
    return this.http.post(
      `${this.baseUrl}reservations/${reservation_id}/document/${document_id}/scan`,
      payload
    );
  }

  applyScanned(reservation_id: number, document_id: number) {
    return this.http.post(
      `${this.baseUrl}reservations/${reservation_id}/document/${document_id}/apply_scan`,
      {}
    );
  }

  updateBulkPaymentCollections(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/bulkChange`,
      payload
    );
  }

  BulkSendToTreasuryPaymentCollections(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/send_to_treasury`,
      payload
    );
  }

  ApproveTreasuryPaymentCollections(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/treasury_approve`,
      payload
    );
  }

  // fines
  collectFine(payload) {
    return this.http.post(`${this.baseUrl}fines/collect`, payload);
  }

  deleteFine(payload) {
    return this.http.post(`${this.baseUrl}fines/delete`, payload);
  }

  makePaymentRequests(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/payment_request`,
      payload
    );
  }

  approvePaymentRequest(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/approve_payment_request`,
      payload
    );
  }

  rejectPaymentRequest(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/reject_payment_request`,
      payload
    );
  }

  linkEOIToReservation(id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/request/${id}/link_eoi`,
      payload
    );
  }

  finalChequeRecieved(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/final_cheque_received`,
      payload
    );
  }

  deliveredToCustomer(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/delivered_to_customer`,
      payload
    );
  }

  startFineAction(reservation_id) {
    return this.http.post(
      `${this.baseUrl}fines/start_fine/${reservation_id}`,
      {}
    );
  }

  endFineAction(reservation_id) {
    return this.http.post(
      `${this.baseUrl}fines/end_fine/${reservation_id}`,
      {}
    );
  }

  changeReservationFine(payload, reservation_id) {
    return this.http.post(
      `${this.baseUrl}fines/change_reservation_fine/${reservation_id}`,
      payload
    );
  }

  addBulkCheque(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/total_bulk_cheques`,
      payload
    );
  }

  getERPLogs(params = {}) {
    return this.http.get(`${this.baseUrl}failed-erp-request`, {
      params: removeNullishFieldsParams(params),
    });
  }

  deleteLog(id) {
    return this.http.delete(`${this.baseUrl}failed-erp-request/${id}`);
  }

  getFailedErpFunctionType(params = {}) {
    return this.http.get(`${this.baseUrl}failed-erp-function-type`, {
      params: removeNullishFieldsParams(params),
    });
  }

  sendFailedERPRequest(id) {
    return this.http.put(`${this.baseUrl}failed-erp-request/${id}`, {});
  }

  changeBulkStatus(payload, params = {}) {
    params = removeNullishFieldsParams(params);
    return this.http.post(
      `${this.baseUrl}paymentCollections/bulkChangeStatus`,
      payload,
      { params }
    );
  }

  editJsonObject(id, payload) {
    return this.http.post(`${this.baseUrl}edit-erp-log-json/${id}`, payload);
  }

  addPaymentCollectionComment(payment_collection_id, payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${payment_collection_id}/add_comment`,
      payload
    );
  }

  // editPaymentCollectionComment(payment_collection_id, payload) {
  //   return this.http.post(
  //     `${this.baseUrl}paymentCollections/${payment_collection_id}/update_comment`,
  //     payload
  //   );
  // }

  editPaymentCollectionComment(payment_collection_id, payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${payment_collection_id}/edit_comment`,
      payload
    );
  }

  approveRefundRequest(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/refund_request/${reservation_id}/approve`,
      payload
    );
  }

  refundRequest(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/refund_request/${reservation_id}/add`,
      payload
    );
  }
  deletePaymentCollectionComment(payment_collection_id) {
    return this.http.delete(
      `${this.baseUrl}paymentCollections/${payment_collection_id}/delete_comment`
    );
  }

  getUnitStatement(id) {
    return this.http.get(
      `${this.baseUrl}reservations/${id}/generate_unit_statement_pdf`
    );
  }

  getChequeSharingLeads(id) {
    return this.http.get(`${this.baseUrl}cheque-sharing-leads/${id}`);
  }

  approvePendingCollected(payload) {
    payload = removeNullishFieldsParams(payload);
    return this.http.post(
      `${this.baseUrl}paymentCollections/approve_pending_collected`,
      payload
    );
  }

  approveBulkAcrossPaymentsModal(payload) {
    payload = removeNullishFieldsParams(payload);
    return this.http.post(
      `${this.baseUrl}paymentCollections/bulk/bulk_across_payments`,
      payload
    );
  }

  rejectPendingCollected(payload) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/reject_pending_collected`,
      payload
    );
  }

  changeMarketingStatus(id) {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/change_marketing_status`,
      {}
    );
  }

  transferToAnotherUnit(reservation_id, payload) {
    return this.http.put(
      `${this.baseUrl}reservations/transfer_to_another_unit/${reservation_id}`,
      payload
    );
  }

  approveTransferToAnotherUnit(id: number) {
    return this.http.post(
      `${this.baseUrl}reservations/approve_transfer_to_another_unit/${id}`,
      {}
    );
  }

  rejectRefundRequest(reservation_id) {
    return this.http.put(
      `${this.baseUrl}reservations/refund_request/${reservation_id}/reject`,
      {}
    );
  }

  approveCollectFine(payload) {
    return this.http.post(
      `${this.baseUrl}fines/approve_pending_collected`,
      JSON.stringify(payload)
    );
  }

  rejectCollectFine(payload) {
    return this.http.post(
      `${this.baseUrl}fines/reject_pending_collected`,
      JSON.stringify(payload)
    );
  }

  printReciptCheque(payment_id) {
    return this.http.get(
      `${this.baseUrl}paymentCollections/${payment_id}/print_receipt`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/reservation-service/reservation.service.ts